import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
export function KeyPlayers() {
  const {
    t
  } = useLanguage();
  const players = [{
    name: 'Jamal Musiala',
    position: t('players.midfielder'),
    club: 'Bayern Munich',
    number: '10',
    image: 'https://cdn.magicpatterns.com/uploads/ik1Vt991iT4KkPpsEyWK4B/image.png'
  }, {
    name: 'Florian Wirtz',
    position: t('players.midfielder'),
    club: 'Bayer Leverkusen',
    number: '17',
    image: 'https://cdn.magicpatterns.com/uploads/7nV4du68QCbbUmwutAeePC/image.png'
  }, {
    name: 'Kai Havertz',
    position: t('players.forward'),
    club: 'Arsenal',
    number: '7',
    image: 'https://cdn.magicpatterns.com/uploads/s81iAaP7d8HuwV1tqBLiZc/image.png'
  }, {
    name: 'Leroy Sané',
    position: t('players.forward'),
    club: 'Bayern Munich',
    number: '19',
    image: 'https://cdn.magicpatterns.com/uploads/fXZ996kMfcXhgP88CXxUgS/image.png'
  }, {
    name: 'Joshua Kimmich',
    position: t('players.midfielder'),
    club: 'Bayern Munich',
    number: '6',
    image: 'https://cdn.magicpatterns.com/uploads/68CoEV25o8qDaW8beQPoVk/image.png'
  }, {
    name: 'Antonio Rüdiger',
    position: t('players.defender'),
    club: 'Real Madrid',
    number: '2',
    image: 'https://cdn.magicpatterns.com/uploads/71ENiE3Kb9KV2U9T7Wq9q7/image.png'
  }];
  return <section className="py-10 md:py-24 bg-[#0a0a0a] relative overflow-hidden" data-id="element-197">
      <div className="container mx-auto px-4 md:px-12 mb-6 md:mb-12" data-id="element-198">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row md:items-end justify-between gap-4" data-id="element-199">
          <div data-id="element-200">
            <h2 className="text-germany-red font-oswald uppercase tracking-widest text-xs md:text-sm font-bold mb-2" data-id="element-201">
              {t('players.label')}
            </h2>
            <h3 className="text-2xl md:text-5xl font-oswald font-bold uppercase" data-id="element-202">
              {t('players.title1')}{' '}
              <span className="text-germany-gold" data-id="element-203">{t('players.title2')}</span>
            </h3>
          </div>
          <a href="https://www.dfb.de/en/national-teams/mens-national-team/team/" target="_blank" rel="noopener noreferrer" className="text-xs md:text-sm font-oswald uppercase tracking-widest text-gray-400 hover:text-white transition-colors flex items-center gap-2 min-h-[44px]" data-id="element-204">
            {t('players.viewSquad')}{' '}
            <span className="text-germany-gold" data-id="element-205">→</span>
          </a>
        </motion.div>
      </div>
      {/* Mobile: 2-column grid / Desktop: 6-column grid */}
      <div className="container mx-auto px-4 md:px-12" data-id="element-206">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-6" data-id="element-207">
          {players.map((player, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="group relative rounded-xl md:rounded-2xl overflow-hidden bg-gradient-to-b from-[#1a1a1a] to-[#111] border border-germany-platinum/10 hover:border-germany-platinum/30 transition-all duration-500" data-id="element-208">
              <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-germany-platinum/0 via-germany-platinum/0 to-germany-platinum/0 group-hover:from-germany-platinum/0 group-hover:via-germany-platinum/50 group-hover:to-germany-platinum/0 transition-all duration-500" data-id="element-209"></div>
              <div className="aspect-[3/4] relative overflow-hidden" data-id="element-210">
                <div className="absolute inset-0 bg-gradient-to-t from-[#111] via-[#111]/30 to-transparent z-10" data-id="element-211"></div>
                <img src={player.image} alt={player.name} loading="lazy" decoding="async" className="w-full h-full object-cover object-top transform group-hover:scale-105 transition-transform duration-700" data-id="element-212" />
                {/* Number Overlay */}
                <div className="absolute top-2 right-2 md:top-3 md:right-3 z-20 font-oswald text-2xl md:text-4xl font-bold text-white/20 group-hover:text-germany-gold/80 transition-colors duration-300" data-id="element-213">
                  {player.number}
                </div>
                {/* Content */}
                <div className="absolute bottom-0 left-0 w-full p-3 md:p-5 z-20" data-id="element-214">
                  <p className="text-germany-gold font-oswald uppercase tracking-widest text-[8px] md:text-[10px] mb-0.5" data-id="element-215">
                    {player.position}
                  </p>
                  <h4 className="font-oswald text-sm md:text-xl font-bold uppercase mb-0.5 leading-tight" data-id="element-216">
                    {player.name}
                  </h4>
                  <p className="text-[10px] md:text-xs text-gray-400 font-light" data-id="element-217">
                    {player.club}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}